$(function() {

    //When import save button clicked...
    $body.on('click', '.save-import', function(e) {
        e.preventDefault();

        //Make them confirm their action before proceeding...
        if(confirm(lang['confirm_import'])) {

            var $btn = $(this);
            var $modal = $(this).closest('.import-ingredients');
            var $btn_text = $(this).find('.btn__text');
            var $btn_icon = $(this).find('.btn__icon');
            var $loading = $modal.find('.save-import-loading');
            var csrf = $("input[name=csrf_token]").val();

            if(typeof(csrf) === 'undefined' || csrf === null) {
                csrf = token;
            }

            var data = new FormData();
            data.append('import_file', $modal.find('#import_file').prop('files')[0]);
            data.append('import_mode', $modal.find('#import_mode').val());
            data.append('ajax', true);
            data.append('csrf_token', csrf);

            //Show loading icon...
            $btn.addClass('btn--icon-only');
            $btn_text.hide();
            $btn_icon.show();
            $loading.show();
            $btn.attr('disabled', 'disabled');

            //Submit the import form request
            ajax_call('post', '/admin/import/add/ingredient', data, function(resp) {

                //Revert button text back
                $btn.removeAttr('disabled');
                $btn.removeClass('btn--icon-only');
                $btn_text.show();
                $btn_icon.hide();
                $loading.hide();

                //If success...
                if(resp.success) {

                    //Show success message
                    show_alert(true, resp.message);

                    //Hide import form and show results div
                    $modal.find('.import-form').hide();
                    $modal.find('.import-results').show();

                    //Refresh listing data
                    var data = get_listing_data();
                    get_listing(data);

                    //Load the results page and show it...
                    ajax_call('get', '/admin/import/' + resp.id, {}, function(resp2) {

                        //Show html view
                        $modal.find('.import-results').html(resp2);

                    });

                    //Otherwise there's an error
                } else {

                    //Show form alert with error message/s
                    show_alert(false, resp.message);

                }

            }, $('body'), false, true, {
                cache: false,
                contentType: false,
                processData: false
            }, false);
        }

    });

    //When update prices save button clicked...
    $body.on('click', '.save-prices-import', function(e) {
        e.preventDefault();

        //Make them confirm their action before proceeding...
        if(confirm(lang['confirm_long_import'])) {

            var $btn = $(this);
            var $modal = $(this).closest('.sync-prices');
            var $btn_text = $(this).find('.btn__text');
            var $btn_icon = $(this).find('.btn__icon');
            var $loading = $modal.find('.save-prices-loading');
            var csrf = $("input[name=csrf_token]").val();

            if(typeof(csrf) === 'undefined' || csrf === null) {
                csrf = token;
            }

            var data = new FormData();
            data.append('import_file', $modal.find('#import_file').prop('files')[0]);
            data.append('ajax', true);
            data.append('csrf_token', csrf);

            //Show loading icon...
            $btn.addClass('btn--icon-only');
            $btn_text.hide();
            $btn_icon.show();
            $loading.show();
            $btn.attr('disabled', 'disabled');

            //Submit the import form request
            ajax_call('post', '/admin/import/sync_prices', data, function(resp) {

                //Revert button text back
                $btn.removeAttr('disabled');
                $btn.removeClass('btn--icon-only');
                $btn_text.show();
                $btn_icon.hide();
                $loading.hide();

                //If success...
                if(resp.success) {

                    //Show success message
                    show_alert(true, resp.message);

                    //Hide import form and show results div
                    $modal.find('.import-form').hide();
                    $modal.find('.import-results').show();

                    //Refresh listing data
                    var data = get_listing_data();
                    get_listing(data);

                    //Load the results page and show it...
                    ajax_call('get', '/admin/import/' + resp.id, {}, function(resp2) {

                        //Show html view
                        $modal.find('.import-results').html(resp2);

                    });

                    //Otherwise there's an error
                } else {

                    //Show form alert with error message/s
                    show_alert(false, resp.message);

                }

            }, $('body'), false, true, {
                cache: false,
                contentType: false,
                processData: false
            }, false);
        }

    });

    //Go back to form button
    $body.on('click', '#import_back_to_form', function(e) {
        e.preventDefault();

        //Hide alert message
        $('.alert').html('');

        //Reset/hide results and show form again
        $('.import-results').hide().html('<span class="fal fa-spinner fa-spin"></span>');
        $('.import-form').show();

    });

});
